import { z } from 'zod'

import { baseCouponSchema } from './coupon.schema'

export const getCouponResponseSchema = baseCouponSchema.extend({
  couponId: baseCouponSchema._def.shape().couponId,
  templateId: z.number(),
  utcUsedAt: z.string().nullable(),
  applicable: z.boolean(),
})

export type GetCouponResponse = z.infer<typeof getCouponResponseSchema>
